import Vue from 'vue';
import Vuex from 'vuex';
import {
  setRouteStorage, getRouteStorage, setUserToken, getUserToken, setRouteNames, getRouteNames,
} from './utils/storage';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userToken: getUserToken(),
    routeQuery: getRouteStorage(),
    routeName: getRouteNames(),
  },
  mutations: {
    User_setUserToken(state, token) {
      state.userToken = token;
      setUserToken(token);
    },
    Storage_setQuery(state, query) {
      state.routeQuery = query;
      setRouteStorage(query);
    },
    Storage_setBread(state, breads) {
      state.routeName = breads;
      setRouteNames(breads);
    },
  },
  actions: {
  },
});
